<script setup lang="ts"></script>

<template>
  <dl class="grid w-full grid-cols-[153px_1fr] gap-2">
    <slot />
  </dl>
</template>
